

module.exports = __webpack_require__.stylable.create(
    "Loader2937556870",
    {"classes":{"root":"Loader2937556870__root","spinner":"Loader2937556870__spinner","path":"Loader2937556870__path"},"vars":{},"stVars":{},"keyframes":{"dash":"Loader2937556870__dash"}},
    "",
    1,
    "Loader2937556870",
    null
);
